import { Route, Routes, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";

import {
  UnderConstruction,
  ProfileNotFound,
  Preview,
  ServerError,
  ConfirmationStatements,
  Dashboard,
  
} from "./views/pages";
import routes from "./core/routes";
import { HTMLAttributes, ReactElement, useEffect } from "react";
import { connect } from "react-redux";
import { AppConstants } from "./core/constants";
import Cookies from "js-cookie";
import PrePayment from "./views/pages/prePayment";
import Transaction from "./views/pages/transaction";

interface Props extends HTMLAttributes<HTMLElement> {
  dispatch?: any;
}
function App(): ReactElement {
  useEffect(() => {
    Cookies.set("domain", "saham", {
      path: "/",
      domain: `${AppConstants.domain}`,
    });
  }, []);
  return (
    <Routes>
      <Route path={routes.PREVIEW} element={<Preview />} />
      <Route path={routes.DASHBOARD} element={<Dashboard />} />
      <Route path={routes.TRANSACTION} element={<Transaction />} />

      <Route path={routes.UNDERCONSTRUCTION} element={<UnderConstruction />} />
      <Route path={routes.PROFILENOTFOUND} element={<ProfileNotFound />} />
      <Route path={routes.SERVERERROR} element={<ServerError />} />
      <Route path={routes.PREPAYMENT} element={<PrePayment />} />
      <Route
        path={routes.ConfirmationStatements}
        element={<ConfirmationStatements />}
      />

      {/* <Route path="*" element={<NotFound />} /> */}
    </Routes>
  );
}

const mapStateToProps = (dispatch: any) => {
  return {
    dispatch,
    userData: dispatch.general.userData,
  };
};
export default connect(mapStateToProps)(App);
